function validate(text) {
  var pattern = /(app:\/\/id\.co\.nurulfikri\.nfjuara\/)\b([-a-zA-Z0-9@:%._\+~#=\/]*)/
  return pattern.test(text)
}

export default {
  validate
}



// WEBPACK FOOTER //
// ./src/services/applink_validator.js